import { lightenHex } from '@/helpers/colors';
import { useThemeStore } from '@/stores/theme';

export const useColors = () => {
  const { primaryColor } = useThemeStore();
  return {
    booked: primaryColor,
    bookedLight: '#9d9d9d',
    available: lightenHex(primaryColor, 0.8),
    availableLight: '#e5e5e5',
  };
};
